import React from 'react'
import { useTranslation } from 'react-i18next'
import TimeSavedIcon from '../../icons/TimeSavedIcon'
import BaseWidget from '../../components/common/BaseWidget'
import NumberWidget from '../../components/common/NumberWidget/NumberWidget'

const TimeSaved = ({ timeSavedMinutes, isLoading }) => {
  const { t } = useTranslation()

  let displayValue

  if (!timeSavedMinutes || timeSavedMinutes === 0) {
    displayValue = '-'
  } else if (timeSavedMinutes > 60) {
    const hours = timeSavedMinutes / 60
    displayValue = Math.round(hours) % 1 === 0 ? `${Math.round(hours)} hours` : `${Math.round(hours * 2) / 2} hours`
  } else {
    displayValue =
      Math.round(timeSavedMinutes) % 1 === 0
        ? `${Math.round(timeSavedMinutes)} minutes`
        : `${Math.round(timeSavedMinutes * 2) / 2} minutes`
  }

  return (
    <BaseWidget carousel={false}>
      <NumberWidget
        key={'timeSaved'}
        label={t('pages.copilotControl.widgets.timeSaved.title')}
        icon={TimeSavedIcon}
        value={displayValue}
        tooltipText={t('pages.copilotControl.widgets.timeSaved.tooltip')}
        isLoading={isLoading}
      />
    </BaseWidget>
  )
}

export default TimeSaved
